<template>
  <div class="sep-component-container" tabindex="0">
    <div
      class="sep-component__select"
      :class="[showOptions ? ' sep-active' : '']"
    >
      <span
        class="sep-component__select--name"
        @click="showOptionsHandler"
        ref="spSelectBox"
        >{{ option ? option['title'] : 'باز کردن فهرست' }}</span
      >
      <v-icon color="gray" :class="showOptions ? 'rotate' : ''">
        mdi mdi-chevron-down
      </v-icon>
      <span class="c-arrow-down" v-if="!showOptions"></span>
      <span class="c-arrow-up" v-if="showOptions"></span>
    </div>
    <v-dialog v-model="showOptions" width="500" ref="sepDropdown">
      <v-card>
        <v-card-text>
          <v-col cols="12">
            <v-text-field
              v-if="searchable == 'true'"
              class="m-1"
              style="font-size: 13px"
              dense
              append-icon="mdi-file-find"
              placeholder="جست و جو کنید"
              solo
              v-model="searchItem"
              @keyup="searchHandler"
            ></v-text-field>
          </v-col>
          <v-list dense class="sep-dropdown-list">
            <v-list-item-group>
              <v-list-item class="sep-bg-label">
                <v-list-item-title class="sp-select-title">
                  <span
                    v-for="(item, i) in columns"
                    :key="i"
                    style="
                      display: inline-block;
                      width: 100px;
                      overflow: hidden;
                      margin-left: 2rem;
                    "
                  >
                    {{ show(item['label']) }}
                  </span>
                  <span></span>
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                @click="selectOption(item)"
              >
                <v-list-item-content>
                  <v-list-item-title class="sp-select-item">
                    <span
                      v-for="(obj, j) in columns"
                      :key="j"
                      style="
                        display: inline-block;
                        width: 100px;
                        overflow: hidden;
                        margin-left: 2rem;
                      "
                      >{{ show(item[obj['key']]) }}</span
                    >
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon v-if="editable && editable == 'true'">
                  <v-icon
                    style="font-size: 15px"
                    color="blue"
                    @click="editOption(item)"
                    >fas fa-edit</v-icon
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>

          <div class="show-more-options">
            <div>
              <v-icon
                color="blue "
                class="sep-show-more"
                @click="expandOptions"
                v-if="!this.hideArrow"
              >
                mdi mdi-chevron-down
              </v-icon>
              <v-icon color="blue" @click="resetOptions" v-else>
                mdi mdi-chevron-up
              </v-icon>
            </div>
            <div class="text-right d-flex">
              <v-btn icon color="blue" @click="addOptions">
                <v-icon>mdi-plus</v-icon>
              </v-btn>

              <v-btn icon color="green" @click="refreshOptions">
                <v-icon class="sep-refresh">mdi-cached </v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'SepCustomSelect',
  props: {
    options: {
      type: Array,
      default: [],
    },
    columns: {
      type: Array,
      default: [],
    },
    value: {
      type: Object,
      default: '',
    },
    editable: {
      type: String,
      default: 'true',
    },

    searchable: {
      type: String,
      default: 'true',
    },
  },

  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 5,
      startRefresh: false,
      searchItem: null,
      searching: false,
      showOptions: false,
      limitOptionsLength: 5,
      hideArrow: false,
      items: [],
      limitedOptions: [],
      option: null,
    };
  },
  computed: {},
  watch: {
    options(after) {
      if (after) {
        if (!after.length) {
          ('**end**');
          this.hideArrow = true;
        }
        this.items.push(...this.options);
      }
    },
    value(after) {
      this.option = after;
    },
  },

  mounted() {
    this.$emit('getOptions', this.itemsPerPage, this.pageNumber);
  },

  methods: {
    showOptionsHandler() {
      this.showOptions = !this.showOptions;
    },

    closeSelectBox() {
      this.resetOptions();
      this.showOptions = false;
    },
    show(item) {
      return item.length > 15 ? item.slice(0, 15) + '...' : item;
    },
    editOption(item) {
      this.$emit('editOption', item);
    },
    addOptions() {
      this.$emit('createNewOption');
    },
    refreshOptions() {
      let c = document.querySelector('.sep-refresh');
      c.classList.add('refresh');
      this.resetOptions();
      setTimeout(() => {
        if (c.classList.contains('refresh')) {
          c.classList.remove('refresh');
        }
      }, 1000);
    },
    searchHandler() {
      if (this.searching) {
        clearTimeout(this.searching);
      }
      this.searching = setTimeout(() => {
        this.searching = true;
        if (this.searchItem.length == 0) {
          this.resetOptions();
        } else {
          this.items = [];
          this.$emit('search', this.searchItem);
        }
      }, 600);
    },
    addtab(href, title) {
      let sendObj = { to: href, name: title };
      this.$store.dispatch('addTab', sendObj);
    },
    resetOptions() {
      this.pageNumber = 1;
      this.items = [];
      this.$emit('getOptions', this.itemsPerPage, this.pageNumber);
      this.hideArrow = false;
    },
    expandOptions() {
      this.pageNumber++;
      this.$emit('getOptions', this.itemsPerPage, this.pageNumber);
    },
    selectOption(option) {
      //  (option);
      this.$emit('input', option);
      this.option = option;
      this.showOptions = false;
    },
  },
};
</script>

<style>
.sep-component-container {
  position: relative;
}

.sep-component__select {
  padding: 0 1rem;
  height: 40px;
  background-color: #fff;
  border: 1px solid #dddddd;
  line-height: 38px;
  display: grid;
  max-width: 500px;
  grid-template-columns: 10fr 1fr;
  border-radius: 5px;
  color: #404040;
  border: 1px solid #bbbbbba3;
}

.sep-component__select--name {
  font-size: 14px;
  padding: 0 0.5rem;
  cursor: pointer;
}

.c-arrow-down {
  justify-self: end;
}

.show-more-options {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  text-align: center;
  z-index: 1000;
  /* position: absolute; */
  width: 100%;
  background: white;
  /* border: 1px solid #d5d5d5; */
  background: white;
  border-top: none;
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgba(0, 0, 0, 0.87) !important;
  z-index: 10000;
  background: white;
}
.v-list {
  padding-bottom: 0;
}
.rotate {
  transform: rotate(180deg);
}
/* .sp-select-item {
  display: flex;
   justify-content: start;
  gap: 5rem;
} */
.sp-select-title {
  width: 100%;
}

.sep-refresh {
  transition: all 4s linear;
}
.refresh {
  animation-name: rotate;
  animation-duration: 1s;
}

.sep-show-more {
  animation-name: translate;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.sep-dropdown-list {
  max-height: 230px;
  overflow: scroll;
}
.sep-bg-label {
  background: rgb(240, 240, 240) none repeat scroll 0% 0%;
  color: #4d4d4d !important;
}
@keyframes translate {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(180deg);
  }
}
</style>
